import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const optionContainerStyle = ({ theme }: Theme) => css`
  label: message-option-button;

  & button,
  & button:hover {
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${theme.colors.white};
    box-shadow: 0px 2px 8px 0px rgba(60, 55, 56, 0.07),
      0px 2px 4px 0px rgba(60, 55, 56, 0.07),
      0px 0px 0px 1px rgba(186, 182, 188, 0.07);
  }
`

export const OptionContainer = styled('div')(optionContainerStyle)
